import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G6_P5_S1_Name: {
    id: `guide06.page05.slide01.name`,
  },
  G6_P5_S2_Name: {
    id: `guide06.page05.slide02.name`,
  },
  G6_P5_S3_Name: {
    id: `guide06.page05.slide03.name`,
  },
  G6_P5_S4_Name: {
    id: `guide06.page05.slide04.name`,
  },
  G6_P5_S5_Name: {
    id: `guide06.page05.slide05.name`,
  },
  G6_P5_S6_Name: {
    id: `guide06.page05.slide06.name`,
  },
  G6_P5_S7_Name: {
    id: `guide06.page05.slide07.name`,
  },
  G6_P5_S8_Name: {
    id: `guide06.page05.slide08.name`,
  },

  //Slide 1
  G6_P5_S1_S1_Title: {
    id: `guide06.page05.slide01.subslide01.title`,
  },
  G6_P5_S1_S1_Description_P1: {
    id: `guide06.page05.slide01.subslide01.description.p1`,
  },
  G6_P5_S1_S1_Description_Quote: {
    id: `guide06.page05.slide01.subslide01.description.quote`,
  },
  G6_P5_S1_S1_Description_Note: {
    id: `guide06.page05.slide01.subslide01.description.note`,
  },
  G6_P5_S1_S1_Description_P2: {
    id: `guide06.page05.slide01.subslide01.description.p2`,
  },
  G6_P5_S1_S2_Title: {
    id: `guide06.page05.slide01.subslide02.title`,
  },
  G6_P5_S1_S2_Description_P1: {
    id: `guide06.page05.slide01.subslide02.description.p1`,
  },
  G6_P5_S1_S2_Description_L1: {
    id: `guide06.page05.slide01.subslide02.description.l1`,
  },
  G6_P5_S1_S2_Description_L2: {
    id: `guide06.page05.slide01.subslide02.description.l2`,
  },
  G6_P5_S1_S2_Description_L3: {
    id: `guide06.page05.slide01.subslide02.description.l3`,
  },
  G6_P5_S1_S2_Description_L4: {
    id: `guide06.page05.slide01.subslide02.description.l4`,
  },
  G6_P5_S1_S2_Description_L5: {
    id: `guide06.page05.slide01.subslide02.description.l5`,
  },
  G6_P5_S1_S2_Description_L6: {
    id: `guide06.page05.slide01.subslide02.description.l6`,
  },
  G6_P5_S1_S2_Description_L7: {
    id: `guide06.page05.slide01.subslide02.description.l7`,
  },
  G6_P5_S1_S2_Description_P2: {
    id: `guide06.page05.slide01.subslide02.description.p2`,
  },
  G6_P5_S1_S2_Description_Note: {
    id: `guide06.page05.slide01.subslide02.description.note`,
  },

  //Slide 2
  G6_P5_S2_Title: {
    id: `guide06.page05.slide02.title`,
  },
  G6_P5_S2_Theory_Dropdown1_Title: {
    id: `guide06.page05.slide02.theory.dropdown1.title`,
  },
  G6_P5_S2_Theory_Dropdown1_Description: {
    id: `guide06.page05.slide02.theory.dropdown1.description`,
  },
  G6_P5_S2_Theory_Dropdown1_ImageTitle: {
    id: `guide06.page05.slide02.theory.dropdown1.image.title`,
  },
  G6_P5_S2_Theory_Dropdown2_Title: {
    id: `guide06.page05.slide02.theory.dropdown2.title`,
  },
  G6_P5_S2_Theory_Dropdown2_Description: {
    id: `guide06.page05.slide02.theory.dropdown2.description`,
  },
  G6_P5_S2_Theory_Dropdown2_ImageTitle: {
    id: `guide06.page05.slide02.theory.dropdown2.image.title`,
  },
  G6_P5_S2_Theory_Dropdown2_Image_Header: {
    id: `guide06.page05.slide02.theory.dropdown2.image.header`,
  },
  G6_P5_S2_Theory_Dropdown3_Title: {
    id: `guide06.page05.slide02.theory.dropdown3.title`,
  },
  G6_P5_S2_Theory_Dropdown3_Description: {
    id: `guide06.page05.slide02.theory.dropdown3.description`,
  },
  G6_P5_S2_Theory_Dropdown3_ImageTitle: {
    id: `guide06.page05.slide02.theory.dropdown3.image.title`,
  },
  G6_P5_S2_Theory_Dropdown3_Image_Header: {
    id: `guide06.page05.slide02.theory.dropdown3.image.header`,
  },
  G6_P5_S2_Theory_Image_Caption: {
    id: `guide06.page05.slide02.theory.image.caption`,
  },

  //Slide 3
  G6_P5_S3_Title: {
    id: `guide06.page05.slide03.title`,
  },
  G6_P5_S3_Theory_Dropdown1_Title: {
    id: `guide06.page05.slide03.theory.dropdown1.title`,
  },
  G6_P5_S3_Theory_Dropdown1_Description: {
    id: `guide06.page05.slide03.theory.dropdown1.description`,
  },
  G6_P5_S3_Theory_Dropdown1_ImageTitle: {
    id: `guide06.page05.slide03.theory.dropdown1.image.title`,
  },
  G6_P5_S3_Theory_Dropdown2_Title: {
    id: `guide06.page05.slide03.theory.dropdown2.title`,
  },
  G6_P5_S3_Theory_Dropdown2_Description: {
    id: `guide06.page05.slide03.theory.dropdown2.description`,
  },
  G6_P5_S3_Theory_Dropdown2_ImageTitle: {
    id: `guide06.page05.slide03.theory.dropdown2.image.title`,
  },
  G6_P5_S3_Theory_Dropdown2_Image_Header: {
    id: `guide06.page05.slide03.theory.dropdown2.image.header`,
  },
  G6_P5_S3_Theory_Image_Caption: {
    id: `guide06.page05.slide03.theory.image.caption`,
  },

  //Slide 4
  G6_P5_S4_Title: {
    id: `guide06.page05.slide04.title`,
  },
  G6_P5_S4_Theory_Description: {
    id: `guide06.page05.slide04.theory.description`,
  },
  G6_P5_S4_Theory_Image_Caption: {
    id: `guide06.page05.slide04.theory.image.caption`,
  },

  //Slide 5
  G6_P5_S5_Title: {
    id: `guide06.page05.slide05.title`,
  },
  G6_P5_S5_Theory_Description: {
    id: `guide06.page05.slide05.theory.description`,
  },
  G6_P5_S5_Theory_Image_Caption: {
    id: `guide06.page05.slide05.theory.image.caption`,
  },

  //Slide 6
  G6_P5_S6_Title: {
    id: `guide06.page05.slide06.title`,
  },
  G6_P5_S6_Theory_Description: {
    id: `guide06.page05.slide06.theory.description`,
  },
  G6_P5_S6_Theory_Image_Caption: {
    id: `guide06.page05.slide06.theory.image.caption`,
  },

  //Slide 7
  G6_P5_S7_Title: {
    id: `guide06.page05.slide07.title`,
  },
  G6_P5_S7_Theory_Description: {
    id: `guide06.page05.slide07.theory.description`,
  },
  G6_P5_S7_Theory_Image_Caption: {
    id: `guide06.page05.slide07.theory.image.caption`,
  },

  //Slide 8
  G6_P5_S8_Title: {
    id: `guide06.page05.slide08.title`,
  },
  G6_P5_S8_Theory_Description: {
    id: `guide06.page05.slide08.theory.description`,
  },
  G6_P5_S8_Theory_Image_Caption: {
    id: `guide06.page05.slide08.theory.image.caption`,
  },
});
